import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { companyInfo } from '../mock';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Kontaktieren Sie uns
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Rufen Sie uns an oder schreiben Sie uns eine E-Mail – wir freuen uns auf Ihre Anfrage!
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 mb-16">
            {/* Phone Card */}
            <Card className="border-2 hover:border-[#2563EB]/50 transition-all hover:shadow-2xl group cursor-pointer">
              <CardContent className="p-8 text-center">
                <a href={`tel:${companyInfo.phone}`} className="block">
                  <div className="w-20 h-20 bg-gradient-to-br from-[#2563EB] to-[#1E40AF] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform shadow-lg">
                    <Phone className="w-10 h-10 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Rufen Sie uns an</h3>
                  <p className="text-3xl font-bold text-[#2563EB] mb-4 group-hover:text-[#1E40AF] transition-colors">
                    {companyInfo.phone}
                  </p>
                  <p className="text-gray-600 mb-4">
                    Montag - Donnerstag: 08:00 - 17:00
                  </p>
                  <Button className="bg-[#2563EB] hover:bg-[#1E40AF] text-white w-full">
                    Jetzt anrufen
                  </Button>
                </a>
              </CardContent>
            </Card>

            {/* Email Card */}
            <Card className="border-2 hover:border-[#2563EB]/50 transition-all hover:shadow-2xl group cursor-pointer">
              <CardContent className="p-8 text-center">
                <a href={`mailto:${companyInfo.email}`} className="block">
                  <div className="w-20 h-20 bg-gradient-to-br from-[#2563EB] to-[#1E40AF] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform shadow-lg">
                    <Mail className="w-10 h-10 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">Schreiben Sie uns</h3>
                  <p className="text-xl font-semibold text-[#2563EB] mb-4 group-hover:text-[#1E40AF] transition-colors break-all">
                    {companyInfo.email}
                  </p>
                  <p className="text-gray-600 mb-4">
                    Wir antworten innerhalb von 24 Stunden<br />
                    Montag - Samstag
                  </p>
                  <Button className="bg-[#2563EB] hover:bg-[#1E40AF] text-white w-full">
                    E-Mail senden
                  </Button>
                </a>
              </CardContent>
            </Card>
          </div>

          {/* Additional Info */}
          <Card className="bg-gradient-to-br from-[#2563EB]/10 to-[#1E40AF]/10 border-2 border-[#2563EB]/20">
            <CardContent className="p-8 text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                MC MaxClean OG
              </h3>
              <p className="text-gray-700 text-lg mb-2">
                <strong>Geschäftsführung:</strong> {companyInfo.manager}
              </p>
              <p className="text-gray-700 text-lg mb-2">
                📍 {companyInfo.address.street}
              </p>
              <p className="text-gray-700 text-lg mb-4">
                {companyInfo.address.city}, {companyInfo.address.country}
              </p>
              <p className="text-[#2563EB] font-semibold text-lg">
                24/7 Notdienst verfügbar
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Google Maps */}
        <div className="mt-12 rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
          <iframe
            title="MC MaxClean OG Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2716.8!2d15.4277!3d47.0579!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDfCsDAzJzI4LjQiTiAxNcKwMjUnMzkuNyJF!5e0!3m2!1sde!2sat!4v1234567890"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};

export default Contact;
